import { SessionRenewalNeededError } from "../auth/errors";

/**
 * React Query's retry rule: never retry a call that needs a new sign-in (it
 * would only fail again until the tech renews; #252), otherwise the default three.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  return !(error instanceof SessionRenewalNeededError) && failureCount < 3;
}
